module.exports = __webpack_public_path__ + "img/drawer.e8011962.svg";